import { Box } from '@mui/material';
import { Column, FooterContainer, FooterNoFlex, List, ListHeading, ListItem } from 'Components/Help/Folder/Footer.styled';
import { ShLogo } from 'Components/SharedComponents/ShLogo';

const Footer = () => {
  return (
    <FooterNoFlex>
      <Column>
        <Box maxWidth={250}>
          <ShLogo />
        </Box>
      </Column>
      <FooterContainer>
        <Column>
          <ListHeading>Heading 1</ListHeading>
          <List>
            <ListItem>Home</ListItem>
            <ListItem>About</ListItem>
            <ListItem>Services</ListItem>
            <ListItem>Contact</ListItem>
          </List>
        </Column>
        <Column>
          <ListHeading>Heading 2</ListHeading>
          <List>
            <ListItem>Products</ListItem>
            <ListItem>Blog</ListItem>
            <ListItem>Portfolio</ListItem>
            <ListItem>Testimonials</ListItem>
          </List>
        </Column>
        <Column>
          <ListHeading>Heading 3</ListHeading>
          <List>
            <ListItem>Privacy</ListItem>
            <ListItem>Terms of Service</ListItem>
            <ListItem>FAQ</ListItem>
            <ListItem>Support</ListItem>
          </List>
        </Column>
      </FooterContainer>

    </FooterNoFlex>
  );
};

export default Footer;
